import { useDateRange } from '../context/DateRangeContext';
import { ConversationRatingProtected } from './ConversationRating.protected';
import { ConversationRatingHeader } from './components/ConversationRatingHeader';
import { FeedbackChartsSection } from './components/FeedbackChartsSection';
import { ConversationRatingConfigDto } from '@/Domain/api/WIdget/dto/ConversationRatingConfig.dto';
import { DateRangeControls } from '@/Domain/components/Shared/DateRangeControls/DateRangeControls';

type Props = {
  isAvailable: boolean;
  configuration?: ConversationRatingConfigDto;
};

export const ConversationRatingPage = ({ isAvailable, configuration }: Props) => {
  const { range, handleRangeChange } = useDateRange();

  if (!isAvailable) {
    return <ConversationRatingProtected />;
  }

  return (
    <div data-testid="conversation-rating-page">
      <main className="mx-auto max-w-7xl py-6 space-y-6">
        <ConversationRatingHeader configuration={configuration!} />

        <DateRangeControls range={range} onRangeChange={handleRangeChange} />

        <div className="mt-6 space-y-6">
          <FeedbackChartsSection range={range} />
        </div>
      </main>
    </div>
  );
};
